import { createApp, defineAsyncComponent } from "vue";
import { eventBus, GlobalEvents } from "@allwyn/utils/global-events";
import { invokeWithLogin } from "../utils/invoke-with-login";
import { launchedFrom, isRgLimitsOpen, RgFrom, RgLimitsAnalytics } from "./analytics/analytics-rg-limits";

let app;

const showRgPopupInternal = (from?: RgFrom) => {
    if (app) {
        // prevent multiple popups
        return;
    }

    const rgLimitsPopup = defineAsyncComponent(() => import("./rg-limits-popup.vue"));

    if (from) launchedFrom.value = from;
    isRgLimitsOpen.value = true;
    app = createApp(rgLimitsPopup);

    const wrapper = document.createElement("div");
    document.body.appendChild(wrapper);

    app.mount(wrapper);

    eventBus.on(GlobalEvents.PermanentExclusion, RgLimitsAnalytics.pushPermanentExclusionFromGame);
};

const showRgPopup = (from?: RgFrom) => invokeWithLogin(() => showRgPopupInternal(from));

const hideRgPopup = () => {
    launchedFrom.value = RgFrom.myAccount;
    isRgLimitsOpen.value = false;
    app.unmount();
    app = null;

    eventBus.off(GlobalEvents.PermanentExclusion, RgLimitsAnalytics.pushPermanentExclusionFromGame);
};

export const useRgLimitsPopup = () => {
    return {
        showRgPopup,
        hideRgPopup,
    };
};
